module.exports = __webpack_public_path__ + "static/media/24a Side Control.0c640510.jpg";